import { Button, ButtonSize, ButtonType } from '@xemplo/button';

import { FINALISE_PAYRUN_COPY } from './finalise-payrun.const';
import { FinalisePayrunButtonProps } from './finalise-payrun.types';

export function FinalisePayrunButton({
  onClick,
  renderButton,
}: Readonly<FinalisePayrunButtonProps>) {
  if (renderButton) return <>{renderButton(onClick)}</>;

  return (
    <Button
      type={ButtonType.Primary}
      ariaLabel={FINALISE_PAYRUN_COPY.title}
      id="finalise-payrun-button"
      onClick={onClick}
      size={ButtonSize.Small}
    >
      {FINALISE_PAYRUN_COPY.title}
    </Button>
  );
}
